module.exports = __webpack_public_path__ + "img/small.feb76a30.jpg";